module.exports = __webpack_public_path__ + "static/media/emojis_15.23c6b417.svg";